import TypingAnimation from "./typing-animation";

const Home = () => {
  return (
    <section className="section1" id="Start">
      <div className="bannerText">
        <h1>I'm Chitraarasu.</h1>
        <br />
        <h3>
          <TypingAnimation />
        </h3>
        <p>
          I am a software developer with experience in iOS, Flutter, Full-stack
          web development, and blockchain. I focus on building scalable,
          user-centric applications across mobile and web platforms. This
          portfolio showcases my professional work and selected projects that
          reflect my problem-solving approach and technical expertise.
        </p>
        <a href="#Contact" className="button">
          <span></span>Hire Me
        </a>
        <a
          href="pdf/Chitraarasu-Resume.pdf"
          target="_blank"
          className="button download__resume"
        >
          <i className="fa fa-download"></i>
          <span></span> Download Resume
        </a>
      </div>
      <img
        src="assets/Passport.webp"
        alt="profile image"
        title="Chitraarasu"
        className="profile"
        draggable="false"
      />
      <ul className="sci">
        <li>
          <a href="https://github.com/chitraarasu" target="_blank">
            <i className="fa fa-github"></i>
          </a>
        </li>
        <li>
          <a href="https://kchitraarasu.wordpress.com/blog/" target="_blank">
            <i className="fa fa-wordpress"></i>
          </a>
        </li>
        <li>
          <a href="https://www.linkedin.com/in/chitraarasu-k/" target="_blank">
            <i className="fa fa-linkedin"></i>
          </a>
        </li>
        <li>
          <a
            href="https://stackoverflow.com/users/15583300/chitraarasu"
            target="_blank"
          >
            <i className="fa fa-stack-overflow"></i>
          </a>
        </li>
        <li>
          <a href="https://twitter.com/chitraarasu" target="_blank">
            <i className="fa fa-twitter"></i>
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/chitraarasu.k/" target="_blank">
            <i className="fa fa-instagram"></i>
          </a>
        </li>
      </ul>
      <div className="element1"></div>
      <div className="element2"></div>
      <div id="scrolldown">
        <a href="#About">
          <span></span>
          <span></span>
          <span></span>
        </a>
      </div>
    </section>
  );
};

export default Home;
